import React, {Fragment} from 'react'
import {Carousel,} from 'antd'
import {ArrowRightOutlined} from '@ant-design/icons';
import './style.css'
import {Link} from "react-router-dom";

export default function AchievementDisplay(props) {
    const {data} = props;
    return (
        <div className='AchievementDisplay'>
            <img className='AchievementDisplay_Background' src='images/HomePage/AchievementDisplay/3.png'/>
            <div className='AchievementDisplayMain'>
                <div className='AchievementDisplay_Left'>
                    <img className='AchievementDisplay_LeftImg'
                         style={{background: `linear-gradient(0deg, rgba(0, 114, 229, 0.7), rgba(0, 114, 229, 0.7)),url('images/tempImgs/资源共享/1.png')`}}/>
                    <div className='AchievementDisplay_LeftBackground'/>
                    <div className='AchievementDisplay_LeftContent'>
                        <div className='AchievementDisplay_LeftTitle'>
                            <div className='AchievementDisplay_LeftTitleBorder'/>
                            <div className='AchievementDisplay_LeftTitleText'>成果展示</div>
                        </div>
                        <div
                            className='AchievementDisplay_LeftIntroduce'>重点聚焦信息与模型共享、多模式智能信息服务等核心能力建设，为业务应用系统和各级业务用户提供卫星数据、场站网实验数据、处理工具、模块、软件系统等资源集成、检验与共享、下载等服务，并提供在线定制、共性技术培训、APP应用等功能。
                        </div>
                        <Link to='/UserLogin'>
                            <div className='AchievementDisplay_LeftButton'>
                                <div className='AchievementDisplay_LeftButtonText'>更多</div>
                                <img className='AchievementDisplay_LeftButtonImg'
                                     src='images/HomePage/AchievementDisplay/more.png' alt=""/>
                            </div>
                        </Link>
                    </div>
                </div>

                <div className='AchievementDisplay_Right'>
                    <div className='AchievementDisplay_RightImg'/>
                    <div className='AchievementDisplay_CardList'>
                        {!!data && data.map((item) => {
                            return <AchievementDisplayCard data={item}/>
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

const AchievementDisplayCard = (props) => {
    const {data} = props;
    return (
        <div className='AchievementDisplayCard'>
            <img className='AchievementDisplayCard_Img' src={data.img||data.collectionCoverUrl}/>
            <div className='AchievementDisplayCard_Title'>{data.title||data.collectionName}</div>
            <div className='AchievementDisplayCard_TitleBottom'/>
        </div>
    )
}